import React from 'react';
import StepShell from './StepShell';
import type { FlowCtx } from './types';

interface Props {
  ctx: FlowCtx;
}

const openWifiSettingsForNoInternet = () => {
  window.ReactNativeWebView?.postMessage(
    JSON.stringify({ action: 'OPEN_WIFI_SETTINGS_FOR_NO_INTERNET' }),
  );
};

const Step7WaitingForInternet: React.FC<Props> = ({ ctx }) => {
  return (
    <StepShell
      stepNumber={3}
      secondary={{ label: 'Cancel', onClick: ctx.onClose }}
      primary={{
        label: 'Go to Settings',
        onClick: openWifiSettingsForNoInternet,
      }}
    >
      <div className="dcf-content--center">
        <h2 className="dcf-step-title">Step 3 of 4: Connect to the internet</h2>
        <div className="dcf-step-bar"></div>
        <div className='dcf-status-icon-container'>
          <div className="dcf-status-icon dcf-status-icon--neutral">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12.55a11 11 0 0 1 14.08 0" strokeLinecap="round" />
              <path d="M1.42 9a16 16 0 0 1 21.16 0" strokeLinecap="round" />
              <path d="M8.53 16.11a6 6 0 0 1 6.95 0" strokeLinecap="round" />
              <circle cx="12" cy="20" r="1" fill="currentColor" />
            </svg>
          </div>
          <p className='dcf-status-icon-text'>Connect to internet</p>
        </div>
        <p className="dcf-step-subtitle-head">Connect your phone to a Wi-Fi network with internet access</p>
        <p className="dcf-step-subtitle text-left">
          Go to Settings &gt; Wi-Fi, select your Wi-Fi network, then return to the
          app. You may safely ignore the &quot;No Internet Connection&quot;
          warning.
        </p>

        {/* <div className="dcf-spinner--large" aria-hidden="true" />
        <p
          className="dcf-step-subtitle"
          style={{ marginTop: 8, fontStyle: 'italic' }}
        >
          Waiting for your phone to reach the internet…
        </p>

        {ctx.connectedSsid && (
          <p className="dcf-step-subtitle">
            Your device will join <strong>{ctx.connectedSsid}</strong> once
            credentials are accepted.
          </p>
        )} */}
      </div>
    </StepShell>
  );
};

export default Step7WaitingForInternet;
